import Container from '@mui/material/Container';
import React, { StrictMode, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { DialogProvider } from './hooks/DialogContext';
import { FiltersAdminProvider } from './hooks/FilterAdminContext';
import { FiltersProvider } from './hooks/FiltersContext';
import Routes from './routes/Routes';
import { isTokenExpired, removeToken } from './services/Auth/Token';

const LabTrace = () => {
    const location = useLocation();
    const history = useHistory();
    const isDashboardAdmin = location.pathname === '/dashboard/admin';

    useEffect(() => {
        // Check token validity on component mount
        const checkTokenValidity = () => {
            if (location.pathname !== '/sign-in'
                && !location.pathname.startsWith('/thank-you')
                && !location.pathname.startsWith('/token-expired')
                && !location.pathname.startsWith('/new-password')
                && !location.pathname.startsWith('/sign-up')
                && !location.pathname.startsWith('/reset-password')) {
                // Check if token is expired
                if (isTokenExpired()) {
                    removeToken();
                    history.push('/sign-in');
                }
            }
        };

        // Check immediately
        checkTokenValidity();

        // Set up periodic token validation check (every 5 minutes)
        const intervalId = setInterval(checkTokenValidity, 5 * 60 * 1000);

        // Clean up on unmount
        return () => clearInterval(intervalId);
    }, [location.pathname, history]);

    return (
        <StrictMode>
            <Container maxWidth={false} sx={{ px: '0px !important' }}>
                <DialogProvider>
                    {isDashboardAdmin ? (
                        <FiltersAdminProvider>
                            <Routes />
                        </FiltersAdminProvider>
                    ) : (
                        <FiltersProvider>
                            <Routes />
                        </FiltersProvider>
                    )}
                </DialogProvider>
            </Container>
        </StrictMode>
    );
};

export default LabTrace;
